/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {
    useContext, useCallback, useEffect
} from 'react';
import _ from 'lodash';
import { useModal } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { BreakpointTrackerContext } from '@jutro/layout';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { useUpdateSubmissionServices, useCheckSubmissionVMDirty, validationUtil } from 'premier-capability-hooks';
import { withRouter } from 'react-router-dom';
import { PremierConstants } from 'premier-constant-service';
import presentationMetadata from "gw-capability-gateway-quoteandbind-PremierSC-react/config/PremierSC-wizard-config.json5";
// import { LoadSaveService } from 'gw-capability-quoteandbind';
import metadata from './HoleInOnePage.metadata.json5';
import messages from './HoleInOnePage.messages';
import styles from '../../HoleInOnePage.module.scss';
import CoveragesPageComponent from "../Coverages/CoveragesPage";
import RiskInformationComponent from '../../components/HoleInOne/RiskInformation/RiskInformationComponent';
import ProductCoverageSelectionComponent from '../../components/HoleInOne/ProductCoverageSelection/ProductCoverageSelectionComponent';

function HoleInOnePage(props) {
    const {
        showConfirm
    } = useModal();

    const { wizardData: submissionVM, updateWizardData, currentStep, history, changeNextSteps, steps } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const translator = useTranslator();
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const { updateSubmission } = useUpdateSubmissionServices();
    const jobNumber = submissionVM.value?.quoteID || submissionVM.value?.jobID;
    const { isDirty } = useCheckSubmissionVMDirty(submissionVM.value);
    const { lineName,jobTypes } = PremierConstants;

    const { authHeader } = useAuthentication();
    const {
        onValidate,
        initialValidation,
        isComponentValid
    } = useValidation('HoleInOnePage');


    const onNext = useCallback(async () => {
        const productCode = _.get(submissionVM.value, 'baseData.productCode');
        // eslint-disable-next-line security/detect-object-injection
        const lobLineName = productCode ? lineName[productCode] : '';
        const response = await updateSubmission(lobLineName, 'HoleInOnePage', submissionVM);
            
        submissionVM.value = response;
    
        return submissionVM;
        },[lineName, submissionVM, updateSubmission]);

    const onSave = useCallback(async () => {
        const subVMCopy = _.clone(submissionVM)
        const productCode = _.get(subVMCopy.value, 'baseData.productCode');

        validationUtil.unSetIsValidationReqFlag(subVMCopy.lobData.speLinLine.coverables.holeInOneCoverable.value, ' ')

        const lobLineName = productCode ? lineName[productCode] : '';
        await updateSubmission(lobLineName, 'HoleInOnePage', subVMCopy);
                        
        return submissionVM;
    },[lineName, submissionVM, updateSubmission]);

    const overrideProps = {
        productCoverageSelection: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.speLinLine.coverables.holeInOneCoverable.productsCoverageSelection"
        },
        riskInformation: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.speLinLine.coverables.holeInOneCoverable.riskInformation"
        },
        
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            productCoverageSelection: ProductCoverageSelectionComponent,
            riskInformation: RiskInformationComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
        [metadata.pageContent, submissionVM, overrideProps]
    );


    const isDisableNext = () => !submissionVM.lobData.speLinLine.coverables.holeInOneCoverable.aspects.subtreeValid

    return (
        <WizardPage onNext={onNext} onSave={onSave} skipWhen={initialValidation} disableNext={isDisableNext()}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

HoleInOnePage.propTypes = wizardProps;
export default withRouter(HoleInOnePage);
